import { render } from "./app-icon-chevron.vue?vue&type=template&id=9c48b46c"
import script from "./app-icon-chevron.vue?vue&type=script&lang=js"
export * from "./app-icon-chevron.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-chevron.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c48b46c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c48b46c', __exports__)) {
    console.log('reload')
    api.reload('9c48b46c', __exports__)
  }
  
  module.hot.accept("./app-icon-chevron.vue?vue&type=template&id=9c48b46c", () => {
    console.log('re-render')
    api.rerender('9c48b46c', render)
  })

}


export default __exports__